/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/** Package version of this component library. */
export const LIBRARY_VERSION = '0.6.15';  // x-release-please-version

/** Identifier of where this component library is sourced from. */
export const ATTRIBUTION_SOURCE_ID = 'NPM';
